export type AiChatQuestionLengthBucket = 'short' | 'medium' | 'long'

export type AiChatLimit = 'conversation' | 'daily' | 'monthly'

export type AiChatCoverageProperties = {
  omitted_pages: number | null
  unreadable_pages: number | null
}

export type AiChatOpenedProperties = AiChatCoverageProperties & {
  questions_left: number | null
}

export type AiChatQuestionSentProperties = AiChatCoverageProperties & {
  question_length_bucket: AiChatQuestionLengthBucket
  questions_left: number | null
}

export type AiChatAnswerCompletedProperties = AiChatCoverageProperties & {
  answer_latency_ms: number
  questions_left: number | null
}

export type AiChatLimitReachedProperties = AiChatCoverageProperties & {
  limit: AiChatLimit
  questions_left: number | null
}

export type AiChatFailedProperties = AiChatCoverageProperties & {
  error_code: string
}

export interface AiChatTracking {
  opened: (properties: AiChatOpenedProperties) => void
  questionSent: (properties: AiChatQuestionSentProperties) => void
  answerCompleted: (properties: AiChatAnswerCompletedProperties) => void
  limitReached: (properties: AiChatLimitReachedProperties) => void
  failed: (properties: AiChatFailedProperties) => void
}

export const questionLengthBucket = (
  length: number,
): AiChatQuestionLengthBucket => {
  if (length <= 200) return 'short'
  if (length <= 800) return 'medium'
  return 'long'
}
